import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Building, 
  Settings, 
  Users,
  BarChart,
  Menu,
  X
} from 'lucide-react';

const sidebarItems = [
  { 
    icon: LayoutDashboard, 
    label: 'Dashboard', 
    path: '/admin' 
  },
  { 
    icon: Building, 
    label: 'Businesses', 
    path: '/admin/businesses' 
  },
  { 
    icon: Users, 
    label: 'Customers', 
    path: '/admin/customers' 
  },
  { 
    icon: BarChart, 
    label: 'Analytics', 
    path: '/admin/analytics' 
  },
  { 
    icon: Settings, 
    label: 'Settings', 
    path: '/admin/settings' 
  },
];

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Sidebar */}
      <div className={`
        fixed top-0 left-0 h-full bg-white shadow-lg transition-all duration-300 z-20
        ${isSidebarOpen ? 'w-64' : 'w-20'}
      `}>
        <div className="flex items-center justify-between h-16 px-4 border-b">
          <Link to="/admin" className="flex items-center">
            <span className={`font-bold text-xl text-primary-600 ${!isSidebarOpen && 'hidden'}`}>
              Admin Portal
            </span>
          </Link>
          <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="p-2 rounded-lg hover:bg-gray-100">
            {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
        
        <nav className="p-4">
          {sidebarItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`
                flex items-center p-3 mb-2 rounded-lg transition-colors
                ${location.pathname === item.path 
                  ? 'bg-primary-50 text-primary-600' 
                  : 'hover:bg-gray-100'
                }
              `}
            >
              <item.icon size={20} />
              <span className={`ml-3 ${!isSidebarOpen && 'hidden'}`}>
                {item.label}
              </span>
            </Link>
          ))}
        </nav>
      </div>

      {/* Main Content */}
      <div className={`
        flex-1 transition-all duration-300
        ${isSidebarOpen ? 'ml-64' : 'ml-20'}
      `}>
        <header className="h-16 bg-white border-b px-6 flex items-center justify-between">
          <h1 className="text-xl font-semibold">
            {sidebarItems.find(item => item.path === location.pathname)?.label || 'Admin'}
          </h1>
          
          {/* Admin Profile Dropdown */}
          <div className="flex items-center space-x-4">
            <span className="text-sm">Admin</span>
            <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-primary-700 font-medium">A</span>
            </div>
          </div>
        </header>

        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;